var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",style:({ width: `${_vm.size}px`, height: `${_vm.size}px` })},[_c('div',{staticClass:"inner",style:({
			width: `${_vm.size - 2 * _vm.imageOffset}px`,
			height: `${_vm.size - 2 * _vm.imageOffset}px`,
			margin: `${_vm.imageOffset}px`
		}),attrs:{"aria-hidden":"true"}},[(_vm.avatarImg)?_c('img',{attrs:{"src":_vm.avatarImg,"alt":""}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }